/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetNewsList200ResponseData } from './GetNewsList200ResponseData'
import {
  GetNewsList200ResponseDataFromJSON,
  GetNewsList200ResponseDataFromJSONTyped,
  GetNewsList200ResponseDataToJSON,
} from './GetNewsList200ResponseData'
import type { GetNewsList200ResponsePaginate } from './GetNewsList200ResponsePaginate'
import {
  GetNewsList200ResponsePaginateFromJSON,
  GetNewsList200ResponsePaginateFromJSONTyped,
  GetNewsList200ResponsePaginateToJSON,
} from './GetNewsList200ResponsePaginate'

/**
 *
 * @export
 * @interface GetNewsList200Response
 */
export interface GetNewsList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetNewsList200Response
   */
  status: boolean
  /**
   *
   * @type {GetNewsList200ResponseData}
   * @memberof GetNewsList200Response
   */
  data: GetNewsList200ResponseData
  /**
   *
   * @type {GetNewsList200ResponsePaginate}
   * @memberof GetNewsList200Response
   */
  paginate?: GetNewsList200ResponsePaginate
}

/**
 * Check if a given object implements the GetNewsList200Response interface.
 */
export function instanceOfGetNewsList200Response(
  value: object
): value is GetNewsList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetNewsList200ResponseFromJSON(
  json: any
): GetNewsList200Response {
  return GetNewsList200ResponseFromJSONTyped(json, false)
}

export function GetNewsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetNewsList200ResponseDataFromJSON(json['data']),
    paginate:
      json['paginate'] == null
        ? undefined
        : GetNewsList200ResponsePaginateFromJSON(json['paginate']),
  }
}

export function GetNewsList200ResponseToJSON(
  value?: GetNewsList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetNewsList200ResponseDataToJSON(value['data']),
    paginate: GetNewsList200ResponsePaginateToJSON(value['paginate']),
  }
}
